/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFoldoutLayout = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M7.786 2h8.428L22 4.599v17.878L15.807 20H8.193L2 22.477V4.599zM9 18h6v-2h2v2.323l3 1.2V5.893l-3-1.348V6h-2V4H9v2H7V4.545L4 5.893v13.63l3-1.2V16h2zm-2-8V8h2v2zm8 0V8h2v2zm-8 4v-2h2v2zm8 0v-2h2v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFoldoutLayout as FoldoutLayout };
